import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUsb2 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M15 2v15c-1.645 0-3 1.355-3 3v17c0 2.75 2.25 5 5 5h4v6h2v-6h4v6h2v-6h4c2.75 0 5-2.25 5-5V20c0-1.645-1.355-3-3-3V2H15zm2 2h16v13H17V4zm2 5v3h4V9h-4zm8 0v3h4V9h-4zM15 19h20c.565 0 1 .435 1 1v17c0 1.668-1.332 3-3 3H17c-1.668 0-3-1.332-3-3V20c0-.565.435-1 1-1z" />
    </svg>
);
export default SvgUsb2;
